/**
 * Tag folding.
 *
 * Tags are free text, so they only work as rule targets if the same word is
 * always stored the same way. The server folds on the way in
 * (`meal_planner.tags.normalise_tag`); this is the same fold, so a tag reads
 * the same in the form and in the rule it feeds.
 */
export function foldTag(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40)
    .replace(/_+$/g, '')
}
